module.exports = __webpack_public_path__ + "static/FileUpload-5e7e02fed41ee314b2e93c33b142e7eb.png";